import _regeneratorRuntime from "/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/esm/toArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { logger } from '@citation-js/core';
import * as response from './response';
import { parseProp, getLabel } from './prop';
import { props, ignoredProps } from './props';

function resolveProp(prop_, entity, unkown) {
  function resolve(_ref, _ref2) {
    var _ref3 = _toArray(_ref),
        prop = _ref3[0],
        parts = _ref3.slice(1);

    var claims = _ref2.claims;

    if (!parts.length) {
      return claims[prop];
    } else if (claims[prop] && claims[prop].length) {
      return resolve(parts, claims[prop][0].value);
    }
  }

  var parts = prop_.split('.');
  unkown.delete(parts[0]);
  return resolve(parts, entity);
}

function prepareValue(statement, entity, unkown) {
  var _ref4;

  if (typeof statement !== 'object') {
    var value = resolveProp(statement, entity, unkown);
    return value && value[0].value;
  }

  var values = (_ref4 = []).concat.apply(_ref4, _toConsumableArray(statement.props.map(function (prop) {
    return resolveProp(prop, entity, unkown);
  }).filter(Boolean)));

  if (statement.values === 'all') {
    return values[0] && values;
  } else {
    return values[0] && values[0].value;
  }
}

export function parseEntity(entity) {
  var data = {
    id: entity.id,
    _wikiId: entity.id,
    source: 'Wikidata'
  };
  var unkown = new Set(Object.keys(entity.claims));

  for (var prop in props) {
    var input = prepareValue(props[prop], entity, unkown);

    if (input) {
      var output = parseProp(prop, input, entity);

      if (output) {
        data[prop] = output;
      }
    }
  }

  var _iterator = _createForOfIteratorHelper(unkown),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _prop = _step.value;

      if (_prop in ignoredProps) {
        continue;
      }

      logger.unmapped('[plugin-wikidata]', 'property', _prop);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (!data.title) {
    data.title = getLabel(entity);
  }

  if (data['reviewed-title'] || data['reviewed-author']) {
    if (data.type.slice(0, 6) !== 'review') {
      data.type = 'review';
    }

    delete data.keyword;
  }

  if (data.recipient) {
    data.type = 'personal_communication';
  }

  if (data.event) {
    data.type = 'paper-conference';
  }

  return data;
}
export function parseEntitiesAsync(_x) {
  return _parseEntitiesAsync.apply(this, arguments);
}

function _parseEntitiesAsync() {
  _parseEntitiesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
    var entities;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            entities = _ref5.entities;
            _context.next = 3;
            return response.parseAsync(entities);

          case 3:
            return _context.abrupt("return", _context.sent.map(parseEntity));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parseEntitiesAsync.apply(this, arguments);
}

export function parseEntities(_ref6) {
  var entities = _ref6.entities;
  return response.parse(entities).map(parseEntity);
}
export { parseEntities as parse, parseEntitiesAsync as parseAsync, parseEntities as default };